function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.287,21.062h18.325c0.166,0,0.299-0.133,0.299-0.299c0-0.164-0.133-0.299-0.299-0.299H7.287  c-0.165,0-0.299,0.135-0.299,0.299C6.988,20.929,7.122,21.062,7.287,21.062z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.287,22.556h18.325c0.166,0,0.299-0.134,0.299-0.299c0-0.164-0.133-0.299-0.299-0.299H7.287  c-0.165,0-0.299,0.135-0.299,0.299C6.988,22.422,7.122,22.556,7.287,22.556z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.291,25.194h21.973c0.426,0,1.162-0.095,1.806-0.695l12.029-11.884c0.352-0.349,0.356-0.915,0.007-1.268  c-0.301-0.305-0.758-0.332-1.106-0.112V7.952l0.195-0.193c0.467-0.462,0.313-0.84-0.345-0.84H20.084  c-0.657,0-1.614,0.338-2.126,0.75c0,0-12.656,10.246-12.688,10.359c-0.978,0.403-1.669,1.364-1.669,2.486v1.991  C3.601,23.989,4.808,25.194,6.291,25.194z M28.6,19.618L39.805,9.132v3.23l-11.175,11.04H28.6V19.618z M5.394,20.515  c0-0.495,0.402-0.896,0.896-0.896h21.114v3.784H6.291c-0.495,0-0.896-0.401-0.896-0.896V20.515z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.32,29.005h18.325c0.166,0,0.299-0.133,0.299-0.299c0-0.165-0.133-0.299-0.299-0.299H9.32  c-0.165,0-0.299,0.134-0.299,0.299C9.021,28.872,9.155,29.005,9.32,29.005z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.32,30.499h18.325c0.166,0,0.299-0.134,0.299-0.299c0-0.166-0.133-0.299-0.299-0.299H9.32  c-0.165,0-0.299,0.133-0.299,0.299C9.021,30.365,9.155,30.499,9.32,30.499z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M44.14,19.29c-0.301-0.304-0.759-0.332-1.106-0.113v-3.281l0.195-0.193c0.468-0.463,0.313-0.84-0.345-0.84H41.27  L30.783,25.222c-0.88,0.82-1.854,0.989-2.52,0.989H6.861c-0.735,0.479-1.226,1.304-1.226,2.245v1.992  c0,1.482,1.207,2.689,2.689,2.689h21.974c0.425,0,1.161-0.096,1.805-0.695l12.029-11.885C44.484,20.21,44.488,19.644,44.14,19.29z   M29.438,31.345H8.324c-0.494,0-0.896-0.402-0.896-0.896v-1.992c0-0.494,0.402-0.896,0.896-0.896h21.114V31.345z M41.838,20.305  l-11.175,11.04h-0.03V27.56l11.205-10.484V20.305z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7.465,36.948h18.326c0.166,0,0.299-0.135,0.299-0.299c0-0.166-0.133-0.299-0.299-0.299H7.465  c-0.165,0-0.298,0.133-0.298,0.299C7.167,36.813,7.3,36.948,7.465,36.948z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M7.465,38.442h18.326c0.166,0,0.299-0.135,0.299-0.299c0-0.166-0.133-0.299-0.299-0.299H7.465  c-0.165,0-0.298,0.133-0.298,0.299C7.167,38.308,7.3,38.442,7.465,38.442z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M41.179,27.12v-2.216l-1.195,1.181v2.163l-11.175,11.04h-0.03v-3.785l1.442-1.349H8.324c-0.849,0-1.629-0.29-2.255-0.772  c-0.387,0.322-0.616,0.518-0.621,0.533c-0.978,0.402-1.668,1.363-1.668,2.484v1.992c0,1.482,1.207,2.689,2.689,2.689h21.974  c0.426,0,1.161-0.096,1.806-0.695l12.029-11.885c0.352-0.348,0.355-0.915,0.007-1.268C41.984,26.929,41.526,26.901,41.179,27.12z   M27.584,39.288H6.469c-0.494,0-0.896-0.402-0.896-0.896v-1.992c0-0.494,0.402-0.896,0.896-0.896h21.115V39.288z"
});

function SvgBooks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.160d51bb.svg";
export { ForwardRef as ReactComponent };